import httpClient from '@/shared/http-auth-data-client';

const fetchLoggedUser = () => httpClient.get('/me');
const getUserById = (userId) => httpClient.get(`/users/?$filter=userId eq ${userId}`);
const guestPermission = () => httpClient.get('/ApplicationPages/GuestPermission');
const userPermission = () => httpClient.get('/ApplicationPages/UserPermission');
export {
  fetchLoggedUser,
  getUserById,
  guestPermission,
  userPermission,
};
